import {ClickAwayListener, Divider, ListItem, Paper, Popper} from "@material-ui/core";
import List from "@material-ui/core/List";
import React, {useEffect, useRef, useState} from "react";
import styles from "./SpellChecker.module.css"
import {translation} from "../../../I18n/i18n";
import {searchCorrection} from "../../../graph-services/GraphServices";

let Element = (props) => {
    let suggestionsRef = useRef ()
    let [suggestions, setSuggestions] = useState ([])
    let [label, setLabel] = useState (`${ translation (props.lang, "Looking") } ...`)

    let handleSuggestions = data => {
        setSuggestions (data)
        Array.isArray (data) && !data.length && setLabel (translation (props.lang, "No suggestions"))
    }

    useEffect (() => {
        if (props.selectedMisspell) {
            setSuggestions ([])
            setLabel (`${ translation (props.lang, "Looking") } ...`)

            searchCorrection (props.lang, props.selectedMisspell)
                .then (r => handleSuggestions (r))
        }
    }, [props.selectedMisspell])

    return <Popper
        ref={ suggestionsRef }
        open={ Boolean (props.selectedMisspell) }
        anchorEl={ props.anchorEl }
        className={ styles.menu }
    >
        <ClickAwayListener onClickAway={ () => props.onClose () }>
            <Paper>
                <List style={ {padding: 0} }>
                    { Array.isArray (suggestions) && !suggestions.length ?
                        <ListItem disabled> { label } </ListItem>
                        : props.selectedMisspell && suggestions
                        .map ((w, i) => <ListItem key={ i }
                                                  button
                                                  onClick={ () => props.correctMisspell (w) }>{ w }</ListItem>)
                    }
                    <Divider/>
                    <ListItem button
                              onClick={ props.ignoreMisspell }> { translation (props.lang, "Ignore correction") } </ListItem>
                    <ListItem button
                              onClick={ props.addToDictionary }> { props.addToDictLabel } </ListItem>
                </List>
            </Paper>
        </ClickAwayListener>
    </Popper>

}

export default Element